export default {
  props: {
    collectFileInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      id: this.$options.name,
    };
  },
};
